module.exports = __webpack_public_path__ + "static/media/vip-message-icon.6a425e26.png";